"use strict";

function getTransitionEndEventName() {
  var transitions = {
    "transition": "transitionend",
    "OTransition": "oTransitionEnd",
    "MozTransition": "transitionend",
    "WebkitTransition": "webkitTransitionEnd"
  };
  var bodyStyle = document.body.style;

  for (var transition in transitions) {
    if (bodyStyle[transition] != undefined) {
      return transitions[transition];
    }
  }
}

var iteratorTimeout, iteratorInterval, iteratorHeld, qtyInput, qtyCount, qtyIncreasing;

window.addEventListener("DOMContentLoaded", () => {
  //document.querySelectorAll('[data-bs-toggle="popover"]').popover();
  //document.querySelectorAll('[data-bs-toggle="tooltip"]').tooltip();
  document.querySelector("#mobile_menu").addEventListener("show.bs.offcanvas", () => {
    document.querySelector("#mobile_menu_toggle").classList.add("active");
  });
  document.querySelector("#mobile_menu").addEventListener("hide.bs.offcanvas", () => {
    document.querySelector("#mobile_menu_toggle").classList.remove("active");
  });
})

for (let elem of document.querySelectorAll(".offcanvas")) {
  elem.addEventListener("show.bs.offcanvas", () => {
    document.body.classList.add("offcanvas-shown");
  });
  elem.addEventListener("hidden.bs.offcanvas", () => {
  document.body.classList.remove("offcanvas-shown");
  });
}

"use strict";

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
(function () {
  var isIe = /(trident|msie)/i.test(navigator.userAgent);

  if (isIe && document.getElementById && window.addEventListener) {
    window.addEventListener('hashchange', function () {
      var id = location.hash.substring(1),
          element;

      if (!/^[A-z0-9_-]+$/.test(id)) {
        return;
      }

      element = document.getElementById(id);

      if (element) {
        if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
          element.tabIndex = -1;
        }

        element.focus();
      }
    }, false);
  }
})();